var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRearrangeOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C6.5 13.1053 7.39474 14 8.5 14C9.60526 14 10.5 13.1053 10.5 12C10.5 10.8947 9.60526 10 8.5 10C7.39474 10 6.5 10.8947 6.5 12ZM13.5 12C13.5 13.1053 14.3947 14 15.5 14C16.6053 14 17.5 13.1053 17.5 12C17.5 10.8947 16.6053 10 15.5 10C14.3947 10 13.5 10.8947 13.5 12ZM6.5 5C6.5 6.10526 7.39474 7 8.5 7C9.60526 7 10.5 6.10526 10.5 5C10.5 3.89474 9.60526 3 8.5 3C7.39474 3 6.5 3.89474 6.5 5ZM13.5 5C13.5 6.10526 14.3947 7 15.5 7C16.6053 7 17.5 6.10526 17.5 5C17.5 3.89474 16.6053 3 15.5 3C14.3947 3 13.5 3.89474 13.5 5ZM6.5 19C6.5 20.1053 7.39474 21 8.5 21C9.60526 21 10.5 20.1053 10.5 19C10.5 17.8947 9.60526 17 8.5 17C7.39474 17 6.5 17.8947 6.5 19ZM13.5 19C13.5 20.1053 14.3947 21 15.5 21C16.6053 21 17.5 20.1053 17.5 19C17.5 17.8947 16.6053 17 15.5 17C14.3947 17 13.5 17.8947 13.5 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRearrangeOutlined);
export default __webpack_public_path__ + "static/media/rearrange_outlined.e830be41.svg";
export { ForwardRef as ReactComponent };